import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { applyClasses, applyProps } from '../shared/js';
import { Button, Grid, Icons } from '..';

import styles from './form.module.scss';

const FormPage = ({ id, slideOut, onBack, print, children, ...props }) => (
  // eslint-disable-next-line react/prop-types
  <Grid className={props.className}>
    <Grid.Row>
      <Grid.Column>
        <div className={styles.pageTop}>
          {onBack && (
            <div className={styles.back}>
              <Button link tertiary underline onClick={onBack}>
                <Icons.Chevron className={styles.chevron} />
                <FormattedMessage id="forms.back" defaultMessage="Back" />
              </Button>
            </div>
          )}
          {print && (
            <div className={cn(styles.back, styles.print)}>
              <Button link underline tertiary onClick={() => window.print()}>
                <Icons.Printer className={styles.chevron} />
                <FormattedMessage id="forms.print" defaultMessage="Print" />
              </Button>
            </div>
          )}
        </div>
        <div
          id={id}
          className={cn(styles.formPage, applyClasses(props, styles), {
            [styles.slideOut]: slideOut,
          })}
          {...applyProps(props)}
        >
          <div className={styles.formPageInner}>{children}</div>
        </div>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

FormPage.propTypes = {
  /** The ID of the page element. Useful to select the page during testing. */
  id: PropTypes.string,
  /** Trigger the slide out animation for the element */
  slideOut: PropTypes.bool,
  /** Callback function when the back button is clicked */
  onBack: PropTypes.func,
  /** Enable the print button on this page */
  print: PropTypes.bool,
  /** Limit the page of the width to 900px, matching sections */
  narrow: PropTypes.bool,
  /** The content of the "page" */
  children: PropTypes.any,
};

FormPage.defaultProps = {
  slideOut: false,
  onBack: undefined,
  print: undefined,
  narrow: undefined,
  children: undefined,
};

export default FormPage;
